<template>
  <div class="groups__form">
    <div
      class="groups__form-content form-content-two-parts"
      ref="parentSidebar"
      id="parentx"
    >
      <div class="inline-part main-info">
        <div class="field">
          <vs-select label="Branch" v-model="branch_id">
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in branches"
            />
          </vs-select>
        </div>
        <div class="field group-name-with-prefix">
          <span
            v-if="
              branch_id &&
              branches.length &&
              branches.find((b) => b.id == branch_id).prefix
            "
          >
            {{ branches.find((b) => b.id == branch_id).prefix }}
          </span>
          <vs-input size="large" label="Name" v-model="name"></vs-input>
        </div>
        <div class="field">
          <compact-picker label="Group color" v-model="color" />
        </div>
        <div class="field">
          <vs-select label="Group type" v-model="group_type_id">
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in groupTypes"
            />
          </vs-select>
        </div>

        <div class="message" v-if="selectedGroupType.with_fixed_rate">
          <vs-alert active="true">
            Знаятия для данного типа группы будут добавлены без учеников. Перед
            расчетом группы нужно будет сначала добавить учеников в каждое
            занятие.
          </vs-alert>
        </div>
        <div class="field">
          <vs-select size="large" label="School Year" v-model="schoolyear_id">
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in years"
            />
          </vs-select>
        </div>

        <div class="field">
          <label for="">Start date</label>
          <v-date-picker v-model="start_from" mode="date" ref="calendar">
            <template v-slot="{ inputValue, inputEvents }">
              <div>
                <vs-input
                  class="calendar-input"
                  :value="`${inputValue}`"
                  v-on="inputEvents"
                  size="large"
                />
              </div>
            </template>
          </v-date-picker>
        </div>
        <div class="field">
          <label for="">End date</label>
          <v-date-picker v-model="end_to" mode="date" ref="calendar">
            <template v-slot="{ inputValue, inputEvents }">
              <div>
                <vs-input
                  class="calendar-input"
                  :value="`${inputValue}`"
                  v-on="inputEvents"
                  size="large"
                  :disabled="endFieldState"
                />
              </div>
            </template>
          </v-date-picker>
          <vs-checkbox v-model="endFieldState">
            To end of schoolyear
          </vs-checkbox>
        </div>
        <div class="field">
          <vs-checkbox v-model="in_holidays">
            Группа работает в праздники
          </vs-checkbox>
        </div>
      </div>
      <div class="inline-part students">
        <div class="field">
          <label for="">Students in Group</label>

          <v-select
            label="name"
            :options="filteredStudents"
            v-model="students"
            :reduce="(item) => item.id"
            :closeOnSelect="true"
            clearable
            multiple
            placeholder="Select students"
            :selectable="studentSelectableHandler"
            :disabled="!schoolyear_id"
            @option:selected="studentSelectHandler"
          >
            <template #option="{ name }">
              <vs-avatar icon="person"></vs-avatar>
              {{ name }}
            </template>
            <template #selected-option="{ name }">
              <vs-avatar icon="person" size="20px"></vs-avatar>
              {{ name }}
            </template>
            <template #list-header>
              <div class="select-header">
                <vs-chip
                  :color="
                    statusID == studentStatuses['allAccepted']
                      ? 'primary'
                      : null
                  "
                >
                  <div @click="filterStudentsList('allAccepted')">All</div>
                </vs-chip>
                <vs-chip
                  :color="
                    statusID == studentStatuses['queue'] ? 'primary' : null
                  "
                >
                  <div @click="filterStudentsList('queue')">Queue</div>
                </vs-chip>
                <vs-chip
                  :color="
                    statusID == studentStatuses['testing'] ? 'primary' : null
                  "
                >
                  <div @click="filterStudentsList('testing')">Testing</div>
                </vs-chip>
              </div>
            </template>
          </v-select>
          <div class="students">
            <div
              class="selected-student"
              v-for="(s, index) in selectedStudents"
              :key="index"
            >
              <vs-avatar icon="person"></vs-avatar>
              <span class="name">{{ s.name }}</span>
              <group
                :id="group.id"
                :color="group.color"
                v-for="group in s.groups.filter(
                  (g) => g.id != group.id && g.is_active
                )"
                :key="group.id"
                class="student-group"
                >{{ group.name }}</group
              >
              <span class="delete-button">
                <vs-button
                  icon="close"
                  type="flat"
                  @click="selectedStudents.splice(index, 1)"
                  title="Remove student"
                  size="small"
                ></vs-button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="inline-part right lessons-manage">
        <div class="lessons-manage__header">
          <h3>
            Lessons ({{ lessons.length }} /
            {{ selectedGroupType.lessons_count || '-' }} per week)
          </h3>
          <vs-button
            icon="add"
            type="flat"
            @click="addLessonHandler"
            v-if="group_type_id && schoolyear_id"
          >
            Add lesson
          </vs-button>
          <div class="lesson-update-from">
            <span>Обновить занятия с даты:</span>
            <v-date-picker
              v-model="lessonUpdateFrom"
              mode="date"
              ref="calendar"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <div>
                  <vs-input
                    class="calendar-input"
                    :value="`${inputValue}`"
                    v-on="inputEvents"
                  />
                </div>
              </template>
              <template #footer>
                <div class="popover-footer">
                  <vs-button
                    @click="_setLessonUpdateFrom(start_from)"
                    class="lesson__update__correct"
                    type="flat"
                  >
                    From group start date
                  </vs-button>
                </div>
              </template>
            </v-date-picker>
          </div>
        </div>
        <div v-if="group_type_id && schoolyear_id">
          <div class="lessons">
            <div class="lesson" v-for="(l, index) in lessons" :key="l.index">
              {{ lessons }}
              {{ l.index }}
              <group-lesson-item
                :index="l.index"
                :lesson="l"
                :schoolyear_id="schoolyear_id"
                :group="group"
                :branch_id="branch_id"
                v-model="lessons[index]"
                @editGroupLesson="editGroupLessonHandler"
                @deleteGroupLesson="deleteGroupLessonHandler"
                @saveGroupLesson="saveGroupLessonFromInlineHandler"
              />
            </div>
          </div>
        </div>
        <div v-else>Select group type and schoolyear</div>
      </div>
    </div>

    <div class="save-popup-button">
      <vs-button icon="save" @click="saveGroup" :disabled="saving">Save</vs-button>
    </div>
  </div>
</template>

<script>
// import VueTimepicker from "vue2-timepicker";
import { Compact } from 'vue-color'
import { mapState } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import GroupLessonItem from './groupLessonItem.vue'
import StudentStatuses from '@/components/common/statuses/studentStatuses'
import Group from '@/components/common/elements/group.vue'

export default {
  name: 'StudentForm',
  props: ['group', 'schoolyearId'],
  data() {
    let data = {
      id: null,
      name: '',
      color: '#ffffff',
      branch_id: null,
      group_type_id: null,
      schoolyear_id: this.schoolyearId || null,
      lessons: [],
      students: [],
      start_from: new Date(),
      lessonPopupActive: false,
      lessonToEdit: {},
      defaultLessonDuration: 60,
      lessonUpdateFrom: new Date(),
      endFieldState: false,
      in_holidays: false,
      end_to: null,
      statusID: 4,
      studentStatuses: StudentStatuses,
      selectedStudents: [],
      saving: false
    }
    if (this.group.id) {
      let endFieldState = false

      let {
        id,
        short_name,
        color,
        lessons_time,
        group_type,
        schoolyear,
        start_from,
        end_to,
        in_holidays,
        created,
        branch,
      } = this.group

      const group_type_id = group_type.id
      const schoolyear_id = schoolyear.id

      if (end_to) {
        end_to = new Date(end_to * 1000)
      } else {
        endFieldState = true
      }
      lessons_time = lessons_time || []

      Object.assign(data, {
        start_from: new Date((start_from || created) * 1000),
        lessons: lessons_time
          .map((l, index) => {
            l.index = index
            return l
          })
          .sort((a, b) => a.date - b.date),
        id,
        name: short_name,
        color,
        group_type_id,
        schoolyear_id,
        end_to,
        in_holidays,
        endFieldState,
        branch_id: branch.id,
      })
    }
    return data
  },
  components: {
    'compact-picker': Compact,
    vSelect,
    Group,
    GroupLessonItem,
  },
  computed: {
    ...mapState({
      groups: (state) => state.groups.groups,
      // group: state => state.groups.singleGroup,
      groupTypes: (state) => state.groups.groupTypes,
      years: (state) => state.years.years,
      teachersList: (state) => state.teachers.teachers,
      rooms: (state) => state.rooms.rooms,
      studentsList: (state) => state.students.students,
      branches: (state) => state.branches.branches,
      currentSchoolyear: (state) => state.years.currentSchoolyear,
    }),
    lessonDuration: function () {
      return this.group_type_id
        ? this.groupTypes.find((t) => t.id == this.group_type_id).duration
        : this.defaultLessonDuration
    },
    selectedGroupType: function () {
      if (this.group_type_id && this.groupTypes.length) {
        return this.groupTypes.find((t) => t.id == this.group_type_id)
      }
      return {}
    },
    filteredStudents: function () {
      return this.studentsList.map((s) => {
        const { name, id } = s
        let visible = false
        if (this.statusID == 4 && !s.status) visible = true
        if (s.status == this.statusID) visible = true
        return {
          id,
          name,
          visible,
        }
      })
    },
  },
  methods: {
    saveGroup: function () {
      this.saving = true
      const {
        id,
        name,
        color,
        lessons,
        group_type_id,
        schoolyear_id,
        branch_id,
        selectedStudents,
        start_from,
        end_to,
        in_holidays,
        lessonUpdateFrom,
      } = this
      let data = {
        name,
        group_type_id,
        schoolyear_id,
        branch_id,
        color: color.hex ? color.hex : color,
        start_from: start_from.getTime() / 1000,
        students: selectedStudents.map((s) => s.id),
        in_holidays,
      }
      if (lessonUpdateFrom) {
        data = {
          ...data,
          update_from: lessonUpdateFrom.getTime() / 1000,
          lessons_time: lessons,
        }
      }
      if (end_to != this.group.end_to) {
        // если меняем дату завершения группы, то отправляем этот параметр,
        // при этом занятия пересчитаются
        data.end_to = end_to ? end_to.getTime() / 1000 : null
      }

      if (id) data.id = id

      this.$store
        .dispatch('groups/saveGroupsAction', {
          groups: data,
        })
        .then(() => {
          this.saving = false
          this.$vs.notify({
            title: 'Success',
            text: `The group has been saved`,
            color: 'success',
            position: 'top-right',
          })
          this.$emit('closePopup')
        })
    },
    editGroupLessonHandler: function (index, oldDate) {
      const lesson = this.lessons[index]
      if (!lesson) {
        this.$vs.notify({
          title: 'Error',
          text: `Lesson not found`,
          color: 'danger',
          position: 'top-right',
        })
      }

      if (!lesson.date) {
        // считаем, что старая настройка занятий, поэтому всегда повторяем
        if (!lesson.freq) lesson.freq = 'weekly'
        lesson.repeat = true
        lesson.interval = 1
        lesson.date = oldDate
      }
      lesson.index = index

      this.lessonToEdit = lesson
      this.lessonPopupActive = true
    },
    deleteGroupLessonHandler: function (index) {
      const i = this.lessons.findIndex(l => l.index == index)
      this.lessons.splice(i, 1)
      this._setLessonUpdateFrom()
    },

    saveGroupLessonFromInlineHandler: function (index, lesson) {
      // Обновляем урок в массиве lessons
      // lessonToEdit уже обновлен через v-model, берем данные оттуда
      if (index >= 0 && index < this.lessons.length) {
        this.$set(this.lessons, index, { ...lesson })
      }
      this._setLessonUpdateFrom()
    },
    closeLessonFormHandler: function () {
      this.lessonToEdit = {}
      this.lessonPopupActive = false
    },
    saveLessonHandler: function (lesson) {
      // Получаем актуальный объект из lessonToEdit (v-model синхронизирован)
      const updatedLesson = this.lessonToEdit || lesson
      const index =
        typeof updatedLesson.index !== 'undefined'
          ? updatedLesson.index
          : lesson.index !== undefined
          ? lesson.index
          : -1

      if (index >= 0 && index < this.lessons.length) {
        // Обновляем существующий урок
        this.$set(this.lessons, index, updatedLesson)
      } else {
        // Добавляем новый урок
        const newLesson = { ...updatedLesson }
        newLesson.index = this.lessons.length
        this.lessons.push(newLesson)
      }

      this.lessonToEdit = {}
      this.lessonPopupActive = false
      this._setLessonUpdateFrom()
    },
    _setLessonUpdateFrom: function (date) {
      this.lessonUpdateFrom = date || new Date()
    },
    studentSelectableHandler: function (option) {
      if (!option.visible) return false
      if (this.students.indexOf(option.id) >= 0) return false
      return true
    },
    studentSelectHandler: function (option) {
      this.$store
        .dispatch('students/getSingleStudentAction', {
          id: option[0].id,
          schoolyear_id: this.schoolyear_id,
        })
        .then((student) => {
          this.selectedStudents.push(student)
        })
      this.students = []
    },

    filterStudentsList: function (status) {
      let statusID = this.studentStatuses[status]
      if (!statusID) {
        console.warn('error in status id')
        return
      }
      this.statusID = statusID
    },
    addLessonHandler: function () {
      const newLesson = {
        teacher: '',
        date: new Date() / 1000,
        room: '',
        price: null,
        repeat: false,
        interval: 1,
        freq: 'weekly',
        untilType: 'year',
        count: null,
        index: this.lessons.length,
        is_online: false,
      }
      this.lessons.push(newLesson)
      // this.lessons.splice(0,0, newLesson)
      
    },
  },
  watch: {
    endFieldState: function (newV) {
      if (newV) {
        this.end_to = null
      }
    },
  },
  created: async function () {
    await this.$store.dispatch('branches/getBranchesAction').then(() => {})
    await this.$store.dispatch('groups/getGroupTypesAction').then(() => {})
    await this.$store.dispatch('years/getYearsAction').then(() => {})
    await this.$store.dispatch('teachers/getTeachersAction').then(() => {})
    await this.$store.dispatch('rooms/getRoomsAction').then(() => {})
    await this.$store.dispatch('students/getStudentsAction').then(() => {})
    if (this.group && this.group.id) {
      await this.$store
        .dispatch('groups/getGroupsStudentsAction', { id: this.group.id })
        .then((students) => {
          this.selectedStudents = students
        })
    }
  },
}
</script>

<style lang="scss">
.groups__popup-content {
  padding: 0;
}
.groups__form {
  .field {
    width: 100%;
    margin-bottom: 25px;
    .vs-input {
      width: 100%;
    }
    &.group-name-with-prefix {
      display: flex;
      align-items: flex-end;
      flex-flow: row;
      gap: 2px;
      & > span {
        padding-bottom: 0.7rem;
        display: flex;
        align-items: center;
        flex-flow: row;

        &:after {
          content: ' - ';
          margin-left: 2px;
        }
      }
    }
  }
  .con-select {
    width: 100%;
  }
  .con-vs-alert {
    overflow: visible;
    .vs-alert {
      overflow: visible;
      & > div {
        margin: 7px 0;
      }
    }
  }
  hr {
    margin: 25px 0;
    color: #eee;
  }
  .day {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
    margin: 10px;
    padding: 10px;
    background-color: #f1f1f1;
    border-radius: 5px;
    box-shadow: 0 0 3px 1px #ccc;
    .day__name {
      vertical-align: top;
      display: inline-block;
      margin: 0 7px;
      padding-bottom: 4px;
    }
    .day__settings {
      display: flex;
      flex-flow: row nowrap;
      vertical-align: middle;
      align-items: flex-end;
      & > * {
        margin: 0 10px;
        align-items: flex-end;
      }
      .day__room,
      .day__teacher {
        width: 100px;
      }
    }
  }
  .vue__time-picker input.has-custom-icon {
    border-radius: 5px;
    border-color: #d7d7d7;
    padding-top: 17px;
    padding-bottom: 17px;
  }
  .lesson__update__correct {
    display: inline-block;
    cursor: pointer;
    padding: 2px;
    margin: 5px;
    border-bottom: 1px dashed;
    &:hover {
      color: var(--font-color);
    }
  }
  .save-popup-button {
    padding: 0 12px;
  }
  .lesson-update-from {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 5px;
    padding: 5px 5px 5px 15px;
    border-radius: 5px;
    background-color: rgba(var(--vs-primary), 0.15);
  }
}
.inline-fields {
  display: flex;
  flex-flow: row nowrap;
  .field {
    flex: 1;
    margin: 0 20px 0;
  }
}
.select-header {
  padding: 0.4rem 0.6rem 0.3rem 1.6rem;
  background-color: #f1f1f1;
  display: flex;
  flex-flow: row nowrap;
}
.inline-part.main-info {
  max-width: 25%;
}
.inline-part.students {
  max-width: 25%;
  background-color: #f1f1f1;
  border-radius: 15px;
}
.selected-student {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin: 5px 0;
  .name {
    flex: 1;
  }
  .student-group {
    font-size: 0.8rem;
    margin: 0 5px;
  }
}
.lessons-manage {
  &__header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 1rem;
  }
}
:deep(.lesson__update__correct) {
  padding: 10px;
}
</style>